export const KEYBOARD_SHORTCUTS_SHOW = 'KEYBOARD_SHORTCUTS_SHOW';

export function keyboardShortcutsShow(show, type) {
  return {
    type: KEYBOARD_SHORTCUTS_SHOW,
    data: { show, type },
  };
}
